export enum KIND {
    Accident = 'ACCIDENT',
    Incident = 'INCIDENT',
}
